
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IOrder} from "@/model/Order/orderInterfaces";
import {IChipStyle, IChipStyles} from "@/model/chipStyleInterfaces";

@Component({})
export default class OrderStatusChip extends Vue {

  @Prop()
  protected order!: IOrder;

  private static readonly chipStyles: IChipStyles = {
    status_order_new: {
      icon: 'mdi-alert-decagram',
      color: 'light-blue',
    },
    status_order_completed: {
      icon: 'mdi-flag',
      color: 'green',
    },
    status_awaiting_customer_dropoff: {
      icon: 'mdi-alert-decagram',
      color: 'pink',
    },
    status_order_awaiting_collect: {
      icon: 'mdi-alert-decagram',
      color: 'indigo',
    },
    status_order_in_route_collect: {
      icon: 'mdi-alert-decagram',
      color: 'blue-grey lighten-1',
    },
    status_order_sp_collected: {
      icon: 'mdi-alert-decagram',
      color: 'purple',
    },
    status_order_assembled: {
      icon: 'mdi-alert-decagram',
      color: 'amber darken-2',
    },
    status_order_in_route_delivery: {
      icon: 'mdi-alert-decagram',
      color: 'blue-grey',
    },
    status_order_sp_delivered: {
      icon: 'mdi-alert-decagram',
      color: 'pink',
    },
    status_order_in_progress: {
      icon: 'mdi-alert-decagram',
      color: 'brown',
    },
    // Don't using at the moment
    status_order_delayed: {
      icon: 'mdi-alert-decagram',
      color: '',
    },
    status_order_sp_cancelled: {
      icon: 'mdi-alert-decagram',
      color: '',
    },
    status_order_client_cancelled: {
      icon: 'mdi-alert-decagram',
      color: '#FF647C',
    },
    status_order_sp_rejected: {
      icon: 'mdi-alert-decagram',
      color: '',
    },
    status_order_professional_search: {
      icon: 'mdi-magnify',
      color: 'primary',
    },
    status_order_professional_confirmed: {
      icon: 'mdi-check-decagram',
      color: 'success',
    },
  }

  protected get chipStyle(): IChipStyle {
    return OrderStatusChip.chipStyles[this.order.status] || {};
  }

}
